import BaseElement from './BaseElement';
import { FavouriteButton } from '../Components/Mediathek/FavoriteButton';
class FavouriteButtonElement extends BaseElement {
    constructor() {
        super(...arguments);
        this.element = FavouriteButton;
    }
}
export default FavouriteButtonElement;
